.root {
  flex: 1;
  display: flex;
  /* Let the row shrink to its container so each panel scrolls on its own, rather than the whole page */
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
  justify-content: space-between;
}

.panel {
  min-height: 0;
  overflow: auto;
}

.buttonColumn {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.transferButton {
  margin: 4px 0;
}

.dndList {
  min-width: 200px;
}
